export enum Roles {
    SUPER_ADMIN = 'Super Admin',
    ADMINISTRADOR = 'Administrador',
    OPERADOR = 'Operador'
}